import React from 'react';

import { Empty, Spin as AntdSpin } from 'antd';

import { BaseSearchResult } from 'types/searchResult';

import { useBaseFormContext } from '../BaseFormContext';
import { setFieldValue } from '../utils';

import BaseSelect, { BaseSelectProps } from './BaseSelect';

interface BaseSelectWithSearchProps<FormValues, OptionType>
  extends Omit<BaseSelectProps<FormValues, OptionType>, 'options'> {
  useSearchEntities: (search?: string) => BaseSearchResult<OptionType>;
  additionalOptions?: OptionType[];
  computeIsSearchActivated?: (value: string) => boolean;
  defaultValue?: string;
}

export default function BaseSelectWithSearch<FormValues, OptionType>({
  useSearchEntities,
  defaultValue,
  additionalOptions,
  computeIsSearchActivated,
  ...props
}: BaseSelectWithSearchProps<FormValues, OptionType>): React.ReactElement {
  const { result, inProgress, search } = useSearchEntities(defaultValue);
  const form = useBaseFormContext<FormValues>();

  function searchHandler(value: string) {
    if (!computeIsSearchActivated || computeIsSearchActivated(value)) {
      search && search(value);
    }
  }

  return (
    <BaseSelect
      {...props}
      onChange={(value, option) => {
        props.onChange && props.onChange(value, option);
        if (option && props.id) {
          setFieldValue(form, props.id, option);
        }
      }}
      showSearch={true}
      options={[...(additionalOptions ?? []), ...result]}
      dropdownMatchSelectWidth={350}
      onSearch={searchHandler}
      notFoundContent={inProgress ? <AntdSpin size="small" /> : <Empty />}
    />
  );
}
